<template>
  <div :class="$style.root">
    <div>
      <template v-if="!level && !noLevel">
        <button
          v-for="option in levelOptions"
          :key="option.value"
          @click="handleLevel(option)"
          type="button"
          :class="optionClass"
          :style="optionStyle"
          :disabled="isDisabledLevel(option.value)"
        >
          {{ option.label }}
        </button>
      </template>
      <template v-else-if="!limit && !noLimit">
        <button
          v-for="option in limitOptions"
          :key="option.value"
          @click="handleLimit(option)"
          type="button"
          :class="optionClass"
          :style="optionStyle"
          :disabled="isDisabledLimit(option.value)"
        >
          {{ option.label }}
        </button>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bgColor: {
      type: String,
    },
    noLevel: {
      type: Boolean,
      default: false,
    },
    noLimit: {
      type: Boolean,
      default: false,
    },
    unlocked: {
      type: Array,
      default: () => ([
        { level: '1', limit: false },
      ]),
    },
  },
  data () {
    return {
      level: null,
      limit: null,
    }
  },
  computed: {
    levelOptions () {
      return [
        {
          label: '第一級',
          value: '1',
        },
        {
          label: '第二級',
          value: '2',
        },
      ]
    },
    limitOptions () {
      return [
        {
          label: '無時間限制',
          value: false,
        },
        {
          label: '有時間限制',
          value: true,
        },
      ]
    },
    currentLevel () {
      return this.noLevel ? undefined : this.level
    },
    optionClass () {
      return [
        this.$style.option,
      ]
    },
    optionStyle () {
      return {
        'background-color': this.bgColor,
      }
    },
  },
  methods: {
    handleLevel (option) {
      this.level = option.value
      if (this.noLimit) {
        this.fireMode(this.level)
      }
    },
    handleLimit (option) {
      this.limit = option.value
      this.fireMode(this.level, this.limit)
    },
    fireMode (level, limit) {
      this.$emit('mode', { level, limit })
    },
    isDisabledLevel (level) {
      return this.unlocked.findIndex((mode) => mode.level == level) == -1
    },
    isDisabledLimit (limit, level = this.currentLevel) {
      return this.unlocked.findIndex((mode) => mode.limit == limit && mode.level == level) == -1
    },
  },
}
</script>

<style lang="scss" module>
.root {
  @apply absolute;
  @apply flex;
  @apply items-center;
  @apply justify-center;
  @apply inset-0;
  @apply m-auto;
}

.option {
  @apply cursor-pointer;
  @apply block;
  font-size: 4rem;
  @apply relative;
  @apply px-12;
  @apply py-4;
  @apply m-8;
  @apply border-none;
  @apply shadow;
  @apply rounded-lg;
  @apply font-sans;
  @apply outline-none;

  &::after {
    @apply absolute;
    @apply inset-0;
    @apply rounded-lg;
    content: '';
    z-index: -1;
    opacity: 0;
    transition: all .3s;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3), 
      inset 0 0 3px 0 rgba(0, 0, 0, 0.2);
  }

  &:hover::after {
    opacity: 1;
  }
}

.option[disabled] {
  color: #808080;

  &:hover::after {
    opacity: 0;
  }

  &:hover {
    @apply cursor-not-allowed;
  }
}
</style>
